"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataLayerScript = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var dataLayerRawScript_1 = require("../helpers/dataLayerRawScript");
/**
 * Add this script inside the head of your page BEFORE harvester is loaded.
 *
 * @param dataLayerProps - Object - object with the following options (all optional):
 * @param accessType - AccessType - Pro | Pub
 * @param author - String - can include multiple, comma separated
 * @param dateModifiedUtc - String
 * @param datePublishedUtc - String
 * @param editor - String - can include multiple, comma separated
 * @param isAdBlock - Boolean
 * @param isLocked - Boolean
 * @param paywallType - PaywallType - None | Partial
 * @param section - String - Other | Analysts | Marketing Pages | Search | Topic Homepage | River | Forecast | Chart | Report | Article | Insights
 * @param keywords - String -  can include multiple, comma separated. I.e. keywords in Content Builder
 * @param geographies - String can include multiple, comma separated. I.e. "United States", "United Kingdom"
 * @param topics - String -  can include multiple, comma separated. I.e. 'More' in Marketing Page's Posts
 * @param unifiedAssetId - String
 * @param connectedUnifiedAssetIds - String - can include multiple, comma separated unifiedAssetIds, i.e. Premium Forecast typically includes/compares multiple "classic" forecasts
 * @param vertical - String -  I.e. categories on insights pages
 * @param wordCount - Number, undefined if empty. Use getWordCount to help.
 * @param userSubscriptionTier - UserSubscriptionTier - pro | pro-plus | pro-with-ikpi | freemium | anonymous.
 *
 * @param removePrevious  _(optional)_ defaults to `true`. Set to `false` to keep existing (previously pushed) `em.pageView` events in `window.dataLayer`
 */
var DataLayerScript = function (_a) {
    var dataLayerProps = _a.dataLayerProps, _b = _a.removePrevious, removePrevious = _b === void 0 ? true : _b;
    return (react_1.default.createElement("script", { type: "text/javascript", dangerouslySetInnerHTML: { __html: (0, dataLayerRawScript_1.getPushPageInfoToDataLayerRawScript)(dataLayerProps, removePrevious) } }));
};
exports.DataLayerScript = DataLayerScript;
//# sourceMappingURL=DataLayerScript.js.map